module.exports = __webpack_public_path__ + "img/img_8.c63a1fa2.png";